import * as React from 'react';

// Components
import CoursePlaylist from 'Screens/CoursePlaylist/Instructor/Containers/CoursePlaylist';
import CourseInfo from 'Screens/CourseInfo/Instructor/CourseInfo';
import Forum from 'Screens/Forum/Instructor/Forum';
import Progress from 'Screens/Progress/Instructor/Progress';
import CourseStudent from 'Screens/CourseStudent/Instructor/CourseStudent';
import PageAdditionForm from 'Screens/PageAdditionForm/Instructor/PageAdditionForm';
import CourseSettings from 'Screens/CourseSettings/Instructor/CourseSettings';
import ChatroomForm from 'Screens/ChatroomForm/Instructor/ChatroomForm';
import ExamsTab from 'Screens/ExamsTab/Instructor/ExamsTab';
import Rga from 'Screens/Rga/Instructor/Rga';
import StudentActivityOptionsList from 'Screens/StudentActivityOptionsList/Instructor/StudentActivityOptionsList';
import TimedQuizAdmin from 'Screens/TimedQuizAdmin/Instructor/TimedQuizAdmin';
import Marks from 'Screens/Marks/Instructor/Marks';
import Schedule from 'Screens/Schedule/Instructor/Schedule';
import EmailArchive from 'Screens/EmailArchive/Instructor/EmailArchive';
import Page from 'Screens/Page/Instructor/Page';

// Assets
import '../Assets/CourseBodyInstructorPage.sass';

interface IProps {
    courseid: any;
    forumid: any;
    callback: any;
    deleteCallBack: any;
    id: any;
    groupid: any;
};

export default class CourseContent extends React.Component<IProps, {}> {

    public render() {
        return <div>{this.getIntendedComponent(this.props.id)}</div>;
    }

    private getIntendedComponent(component_id) {
        switch (component_id) {
            case 'content':
                return <CoursePlaylist courseid={this.props.courseid} groupid={this.props.groupid} />;
            case 'information':
                return <CourseInfo course={this.props.courseid} />;
            case 'discussion-forum':
                return <Forum id={this.props.forumid} />;
            case 'progress':
                return <Progress course={this.props.courseid} />;
            case 'students':
                return <CourseStudent courseid={this.props.courseid} />;
            case 'add-page':
                return <PageAdditionForm heading='Add Page' saveCallBack={this.props.callback} />;
            case 'settings':
                return <CourseSettings courseid={this.props.courseid} />;
            case 'chat':
                return <ChatroomForm teacher={true} course={this.props.courseid} />;
            case 'exams':
                return <div id={`exams-tab${this.props.courseid}`}>
                    <ExamsTab courseid={this.props.courseid} />
                </div>;
            case 'report-grading':
                return <Rga courseid={this.props.courseid} />;
            case 'student-activity':
                return <StudentActivityOptionsList courseid={this.props.courseid} />;
            case 'timed-quiz':
                return <TimedQuizAdmin courseid={this.props.courseid} />;
            case 'marks':
                return <Marks courseid={this.props.courseid} />;
            case 'schedule':
                return <Schedule course={this.props.courseid} />;
            case 'email':
                return <EmailArchive courseid={this.props.courseid} />;
            default:
                if (this.props.id > 0)
                    return <Page id={this.props.id} deleteCallBack={this.props.deleteCallBack} />;
                window.history.replaceState('', '', `/courseware/course/${this.props.courseid}/content/`);
                return <CoursePlaylist groupid={this.props.groupid} courseid={this.props.courseid} />;
        }
    }
};
